import _ from "lodash";

export const selectedEntreesCounter = (selectedMeals) => {
  let count = 0;
  selectedMeals.entrees.forEach((item) => {
    count += item.quantity;
  });

  return count;
};

export const checkForSoldOuts = (data, charge) => {
  let _soldOuts = false;
  let _selectedMeals = _.concat(data.breakfasts, data.entrees);

  _selectedMeals.forEach(function (meal) {
    let _selectedItemQuantity = 0;
    if (typeof charge !== "undefined" && typeof charge.meals !== "undefined") {
      charge.meals.forEach(function (mealInner) {
        if (mealInner.id === meal.id) {
          _selectedItemQuantity = mealInner.quantity;
          return false;
        }
      });
    }

    let limitQCheck = meal.stockCapacity - meal.mealBoughtQuantity + _selectedItemQuantity - meal.quantity;

    if (meal.stockCapacity === 0 || limitQCheck < 0) {
      _soldOuts = true;
      return false;
    }
  });

  return _soldOuts;
};


export function setBreakfastsLimitation(dietType, limitations) {
  return (dietType === "Mediterranean Plan"|| dietType === "Diabetes Plan" || dietType === "Heart-Friendly Plan")  ? 0 : limitations.breakfastsMinLimit + limitations.additionalMealsMinLimit.breakfastsMinLimit;
}
export function setEntreesLimitation(limitations) {
  return limitations.entreesMinLimit + limitations.additionalMealsMinLimit.entreesMinLimit;;
}
